import { head } from 'lodash';

export default [ '$window', 'offerService', 'startTimeService', 'availabilityService', function ($window, offerService, startTimeService, availabilityService) {
  this.item = null;

  const setItem = (item) => {
    this.item = item;
  };

  const getItem = () => {
    return this.item;
  };

  const hasItem = () => {
    return !!(this.item && Object.keys(this.item).length > 0);
  };

  const updateAvailability = (availableDay) => {
    return new Promise(resolve => {
      if (!availableDay) {
        return resolve();
      }

      this.item.date = availableDay.date;
      this.item.available = availableDay.available;

      if (!this.item.available) {
        return resolve();
      }

      this.item.price = availableDay.price;
      this.item.original = availableDay.original_price;
      this.item.phone_only = availableDay.phone_only;

      if (this.item.phone_only) {
        this.item.available = false;
      }

      availabilityService.resetSingleTimes();

      let apiRequests = [];

      if (this.item.available) {
        apiRequests.push(new Promise(resolves => {
          return startTimeService.getStartTimesSetPreferred(this.item)
            .then(itemWithTimes => {
              setItem(itemWithTimes);
              resolves();
            });
        }));
      }

      if (availableDay.offer) {
        if (!this.item.offer
            || (this.item.offer
              && this.item.offer.id !== availableDay.offer.id)) {
          this.item.offer = {};

          apiRequests.push(new Promise(resolves => {
            return offerService.getDetails(availableDay.offer.id)
              .then(offerDetails => {
                this.item.offer = offerDetails;
                resolves();
              });
          }));
        }
      } else {
        this.item.offer = null;
      }

      if ($window.fpInput
          && typeof $window.fpInput === 'object'
          && typeof $window.fpInput.setDate === 'function') {
        $window.fpInput.setDate(this.item.date, false, 'Y-m-d');
      }

      return Promise.all(apiRequests)
        .then(() => {
          resolve();
        });
    });
  };


  const setupItemAvailability = (availability, date) => {
    return updateAvailability(availability.find((event) => event.date === date && event.available === true)
      || availability.find((event) => event.available === true)
      || head(availability));
  };

  return {
    getItem,
    setItem,
    hasItem,
    updateAvailability,
    setupItemAvailability
  };
} ];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/item/services/item.service.js